const productsGql = `
  cursor
  node {
    status
    tags
    hasOnlyDefaultVariant
    hasOutOfStockVariants
    publishedAt
    vendor
    title
    handle
    id
    images(first: 1) {
      edges {
        node {
          src
        }
      }
    }
    totalInventory
    variants(first: 90) {
      edges {
        node {
          id
          displayName
          price
          sku
          inventoryPolicy
          inventoryQuantity
          title
        }
      }
    }
  }
`;

const collectionsGql = `
  cursor
  node {
    id
    handle
    title
    updatedAt
    descriptionHtml
    sortOrder
    templateSuffix
    image {
      url
    }
  }
`;

export const findProducts = ({ limit, cursor }) => `
  {
    products(first: ${limit}, query: "status:DRAFT,ACTIVE", sortKey: ID${cursor ? `, after: "${cursor}"` : ""}) {
      pageInfo {
        hasNextPage
      }
      edges {
        ${productsGql}
      }
    }
  }
`;

export const findCollections = ({ limit, cursor }) => `
  {
    collections(first: ${limit}, query: "status:DRAFT,ACTIVE", sortKey: ID${cursor ? `, after: "${cursor}"` : ""}) {
      pageInfo {
        hasNextPage
      }
      edges {
        ${collectionsGql}
      }
    }
  }
`;

export const findProductsByCollectionId = ({ limit, collectionId, cursor }) => `
    {
      products(first: ${limit}, query: "status:DRAFT,ACTIVE AND collection_id:${collectionId}"${cursor ? `, after: "${cursor}"` : ""}) {
        pageInfo {
          hasNextPage
        }
        edges {
          ${productsGql}
        }
      }
  }
`;

export const findProductsNextPage = ({ cursor }) => `
  {
    products(first: 50, after: ${cursor ? '"' + cursor + '"' : cursor}) {
      pageInfo {
        hasNextPage
      }
      edges {
        ${productsGql}
      }
    }
  }
`;

export const findProductByTitleOrSku = ({ query }) => `
  {
    products(first: 50, query: "title:*${query}* OR sku:*${query}*") {
      pageInfo {
        hasNextPage
      }
      edges {
        ${productsGql}
      }
    }
  }
`;

export const findProductsByTag = ({ query }) => `
  {
    products(first: 50, query: "tag:'${query}'") {
      pageInfo {
        hasNextPage
      }
      edges {
        ${productsGql}
      }
    }
  }
`;

export const findProductsByVendor = ({ query }) => `
  {
    products(first: 50, query: "vendor:'${query}'") {
      pageInfo {
        hasNextPage
      }
      edges {
        ${productsGql}
      }
    }
  }
`;

export const findCollectionByTitle = ({ query }) => `
  {
    collections(first: 50, query: "title:*${query}*") {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          title
          handle
          image {
            src
          }
        }
      }
    }
  }
`;

export const findProductByTitleOrSkuNextPage = ({ query, cursor }) => `
  {
    products(first: 50, query: "title:*${query}* OR sku:*${query}*", after: ${cursor ? '"' + cursor + '"' : cursor}) {
      pageInfo {
        hasNextPage
      }
      edges {
        ${productsGql}
      }
    }
  }
`;

export const findProductsByTagNextPage = ({ query, cursor }) => `
  {
    products(first: 50, query: "tag:'${query}'", after: ${cursor ? '"' + cursor + '"' : cursor}) {
      pageInfo {
        hasNextPage
      }
      edges {
        ${productsGql}
      }
    }
  }
`;

export const findProductsByVendorNextPage = ({ query, cursor }) => `
  {
    products(first: 50, query: "vendor:'${query}'", after: ${cursor ? '"' + cursor + '"' : cursor}) {
      pageInfo {
        hasNextPage
      }
      edges {
        ${productsGql}
      }
    }
  }
`;
